module.exports = __webpack_public_path__ + "img/06-fes-contributes.438e5dcf.jpg";